'use strict';
import axios from 'axios'
import Qs from 'qs'
import store from '../store/store'
import router from '../router'
import { Message } from 'element-ui';

// 添加响应拦截器
axios.interceptors.request.use((res) => {
    //在发送请求之前做某件事
    const loginData = JSON.parse(localStorage.getItem('loginData'))
    if (loginData && loginData.token) {
        res.headers['Authorization'] = loginData.token
    } else {
        store.commit('signOut')
        router.push({
            name: 'login'
        })
    }
    store.commit('onClickButton');
    //console.log('onClickButton');
    return res;
},(error) =>{
    _.toast("错误的传参", 'fail');
   // console.log('%c   错误的传参:', 'fail');
    return Promise.reject(error.message);
});

axios.interceptors.response.use(function(res) {
    // 对响应数据做点什么
    if (typeof res.data === 'string' && res.data.length > 0) {
        res.data = JSON.parse(res.data);
    }
    return res;
}, function(error) {
    //打印异常周边
    // if(error.request.status != 200){
    //   console.log(error.config);
    //   console.log(error.request);
    // }
    if (error.message === 'Network Error') {
        //此处断网和接口404都会被拦截到， error.request.status === 0【姑且认为是axios的坑吧】
        console.log('%c   404的API:', 'color:#333;font-weight:700;');
        console.log('%c   ' + error.config.url, 'color:#666;');
    }
    if (error.code === 'ECONNABORTED') {
        //我们在这里可以进行超时拦截
        console.log('%c   超时的API:', 'color:#333;font-weight:700');
        console.log('%c   ' + error.config.url, 'color:#666;');
    }

    return Promise.reject(error.message);
});



var config = {
    //请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
    url: '',

    method: 'get', // 请求方法，默认是GET方法

    // 基础url前缀
    //baseURL: 'http://192.168.1.77:8081',
    //baseURL: 'http://localhost:8081',
    // baseURL: 'http://127.0.0.1:8081',
     baseURL: 'https://app.zkzwjk.com:8082',
    // baseURL:'http://10.34.1.76:8081',
    //baseURL:'http://139.224.18.228:8081',
    transformRequest: [function(data) { //允许在请求发送到服务器之前修改该请求
        // data.CustData = JSON.stringify(data.CustData);
        //由于使用的form-data传数据所以要格式化
        data = Qs.stringify(data);
        return data;
    }],


    transformResponse: [function(data) { //允许在数据传递到then/catch之前修改response数据
        if (data.errorCode === 'InvalidAuthorization') {
            Message('认证已失效！请重新登录');
            store.commit('signOut');
        }
        return data;
    }],

    headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded',
    }, //包含了http请求的各种信息

    params: { //params是发送请求的查询参数对象，对象中的数据会被拼接成url?param1=value1&param2=value2

    },

    paramsSerializer: function(params) { //params参数序列化器。
        return Qs.stringify(params)
    },

    //post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
    data: {

    },

    timeout: 50000, //请求超时设置，单位为毫秒


    withCredentials: false, // default    表明是否有跨域请求需要用到证书

    // 表示服务器将返回响应的数据类型
    responseType: 'json', // default  有arraybuffer、blob、document、json、text、stream这6个类型



    // onUploadProgress: function (progressEvent) {  //允许在上传过程中的做一些操作
    //   // Do whatever you want with the native progress event
    // },
    //
    //
    // onDownloadProgress: function (progressEvent) {  //允许在下载过程中的做一些操作
    //   // Do whatever you want with the native progress event
    // },


    maxContentLength: 2000, // 定义了接收到的response响应数据的最大长度。


    validateStatus: function(status) { //定义了根据HTTP响应状态码决定是否接收或拒绝获取到的promise。如果 validateStatus 返回 true (或设置为 null 或 undefined ),promise将被接收;否则,promise将被拒绝。
        return status >= 200 && status < 300; // default
    },


    maxRedirects: 5, // default
}

export default config;



// WEBPACK FOOTER //
// ./src/api/config.js